import { useCallback } from 'react';
import { CurrencyInput, type CurrencyInputProps } from './CurrencyInput.tsx';

export interface DecimalInputProps
  extends Omit<CurrencyInputProps, 'currency'> {
  asNumber?: boolean;
}

/**
 * Campo per input di tipo Decimal che non sono valute, ad esempio
 * numeri con la virgola come la quantità.
 */
export function DecimalInput(props: DecimalInputProps) {
  const { asNumber, ...otherProps } = props;

  const transformValueToNumber = useCallback(
    (parsedValue: string | null) =>
      parsedValue != null ? Number(parsedValue) : parsedValue,
    [],
  );

  return (
    <CurrencyInput
      {...otherProps}
      hideCurrency
      transformValue={asNumber ? transformValueToNumber : null}
    />
  );
}
